import type { LocalizedString } from "../localization";

/** Mirrors `NotificationType` values; kept local to avoid FireCMS in unit tests. */
export const NOTIFICATION_DEF_IMPORT_TYPES = [
  "custom",
  "unit_unlocked",
  "top_3",
  "ranking_individual_ended",
  "ranking_team_ended",
  "personal_unit_completed",
  "personal_treasure_opened",
  "personal_levels_100",
  "team_member_joined",
  "team_member_left",
  "team_member_unit_completed",
  "team_multi_leader_penalty",
  "team_member_personal_100",
  "team_levels_100",
] as const;

export type NotificationDefImportType =
  (typeof NOTIFICATION_DEF_IMPORT_TYPES)[number];

export type NotificationDefImportItem = {
  type: NotificationDefImportType;
  title: LocalizedString;
  body: LocalizedString;
};

export type NotificationDefImportResult = {
  imported: number;
  failed: Array<{ index: number; key: string; reason: string }>;
};
